import React, { forwardRef } from 'react';
import { useMergeRefs } from '@floating-ui/react';

import { usePopoverContext } from './usePopoverContext';

type Props = {
  qaTest?: string;
};

export const WpPopoverToggle = forwardRef<HTMLElement, React.HTMLProps<HTMLElement> & Props>(function WpPopoverToggle(
  { children, qaTest, ...props },
  propRef
) {
  const context = usePopoverContext();
  const childrenRef = (children as any).ref;
  const ref = useMergeRefs([context.refs.setReference, propRef, childrenRef]);

  if (React.isValidElement(children)) {
    return React.cloneElement(
      children,
      context.getReferenceProps({
        ref,
        ...props,
        ...children.props,
        'data-state': context.open ? 'open' : 'closed',
        'data-test': qaTest,
      })
    );
  }
  return null;
});

export default WpPopoverToggle;
